module.exports = __webpack_public_path__ + "static/media/hearts_K.481f63df.png";